import { Button } from "components/ui/controls/Button"
import { Topbar } from "components/ui/shared/Topbar"
import styled from "styled-components"
import { ModeuleNotAvailable } from "components/ui/shared/ModuleNotAvailable"
import { MaterialIcon } from "components/ui/shared/MaterialIcon"
//import { useNavigate } from "react-router-dom"

export const Repositories = () => {
    //const navigate = useNavigate()
    return (
        <>
            <Topbar breacrumb={['Repository']}>
                <Button
                    type='primary'
                    text="Ny repository"
                    prefix={<MaterialIcon name='add' weight={300}/>}
                    //onClick={() => navigate('/projects/new')}
                />
            </Topbar>
            <StyledRepositoriesContainer>
                <div className="repositoriesHeader">
                     <span className="title">
                        Versjonslagring
                    </span>
                </div>
                <div className="repositoriesContent">
                    <ModeuleNotAvailable/>
                </div>
            </StyledRepositoriesContainer>

        </>
    )
}

const StyledRepositoriesContainer = styled.div`
    padding-left: ${({theme}) => theme.spacing.xl};
    padding-right: ${({theme}) => theme.spacing.xl};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    div.repositoriesHeader 
    {
        margin-bottom: ${({theme}) => theme.spacing.lg};

        span.title
        {
            font-size: ${({theme}) => theme.fontSize.xxl};
            font-weight: 500;
            display: block;
            margin-bottom: ${({theme}) => theme.spacing.lg};
        }

        div.options
        {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            gap: ${({theme}) => theme.spacing.md};
            

            > div
            {
                display: flex;
                gap: ${({theme}) => theme.spacing.md};
            }
        }
    }

    div.repositoriesContent
    {
        flex: 1 1 auto;
        overflow: auto;
    }
`